interface Props {
  rangeLow: number
  rangeHigh: number
  currentPrice: number
}

function usd(n: number) {
  return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

export function LpRangeViz({ rangeLow, rangeHigh, currentPrice }: Props) {
  if (!rangeLow || !rangeHigh || !currentPrice) return null

  // Display 15% context beyond range on each side
  const displayMin = rangeLow * 0.85
  const displayMax = rangeHigh * 1.15
  const totalDisplay = displayMax - displayMin

  const toPct = (v: number) => Math.max(0, Math.min(100, ((v - displayMin) / totalDisplay) * 100))

  const rangeStartPct = toPct(rangeLow)
  const rangeWidthPct = toPct(rangeHigh) - rangeStartPct
  const currentPct = toPct(currentPrice)

  const inRange = currentPrice >= rangeLow && currentPrice <= rangeHigh

  return (
    <div className="rounded-xl border border-white/5 bg-surface-card p-4">
      <div className="text-[10px] font-semibold uppercase tracking-wider text-gray-500 mb-3">Price Range</div>

      {/* Bar */}
      <div className="relative h-5 rounded-full bg-white/[0.04] overflow-hidden mb-2">
        {/* Active range fill */}
        <div
          className="absolute top-0 bottom-0 rounded-full bg-accent-blue/30"
          style={{ left: `${rangeStartPct}%`, width: `${rangeWidthPct}%` }}
        />
        {/* Current price needle */}
        <div
          className={`absolute top-0 bottom-0 w-0.5 ${inRange ? 'bg-accent-green' : 'bg-accent-yellow'}`}
          style={{ left: `${currentPct}%`, transform: 'translateX(-50%)' }}
        />
      </div>

      {/* Labels row */}
      <div className="relative h-6">
        <span className="absolute text-[10px] text-gray-400" style={{ left: `${rangeStartPct}%`, transform: 'translateX(-50%)' }}>
          {usd(rangeLow)}
        </span>
        <span
          className={`absolute text-[10px] font-semibold ${inRange ? 'text-accent-green' : 'text-accent-yellow'}`}
          style={{ left: `${currentPct}%`, transform: 'translateX(-50%)' }}
        >
          ▲ {usd(currentPrice)}
        </span>
        <span className="absolute text-[10px] text-gray-400" style={{ left: `${rangeStartPct + rangeWidthPct}%`, transform: 'translateX(-50%)' }}>
          {usd(rangeHigh)}
        </span>
      </div>

      {/* Status */}
      <div className={`mt-2 text-center text-[10px] font-medium ${inRange ? 'text-emerald-400' : 'text-amber-400'}`}>
        {inRange ? '✓ Price is inside range — fees are being earned' : '⚠ Price is outside range — no fees collected'}
      </div>
    </div>
  )
}
